import { render, staticRenderFns } from "./preloader-icon.vue?vue&type=template&id=fb095246&"
var script = {}


/* normalize component */
import normalizer from "!../../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports